<div class="confirm-dialog">
	<h3 class="title">{{ dialogTitle | translate }}</h3>

	<div class="actions">
		<app-button
			appearance="outline"
			size="xl"
			(clicked)="cancel()"
		>
			{{ cancelText | translate }}
		</app-button>
		<app-button
			appearance="negative"
			size="xl"
			[isLoading]="isLoadingConfirm"
			(clicked)="confirm()"
		>
			{{ confirmText | translate }}
		</app-button>
	</div>
</div>
